import React from 'react'

function Privacy() {
    return (
        <>
            <div className="flex flex-col mt-20">
                <div className="w-full text-5xl font-bold text-right text-zinc-900 max-md:max-w-full">
                    سياسة الخصوصية
                </div>
                <div className="mt-8 w-full text-base text-right text-zinc-900 max-md:max-w-full">
                    يجمع هذا الموقع بعض البيانات الشخصية من مستخدميه، قد يخضع المستخدمون
                    لمعايير حماية مختلفة وقد تنطبق معايير أوسع على البعض. لمعرفة المزيد حول
                    معايير الحماية ، يمكن للمستخدمين الرجوع إلى قسم التطبيق.
                </div>
                <div className="flex flex-col justify-start px-5 py-8 mt-8 w-full rounded-xl border border-solid backdrop-blur-[10px] bg-zinc-50 border-zinc-300 max-md:max-w-full">
                    <div className="self-start text-xl font-bold text-right text-black whitespace-nowrap">
                        جمع واستخدام البيانات الشخصية
                    </div>
                    <div className="mt-2 text-base text-justify text-zinc-900 max-md:max-w-full">
                        بياناتك الشخصية هي معلومات التعريف بشخصيتك مثل اسمك، عنوانك، البريد
                        الإلكتروني، رقم الهاتف، ورقم بطاقة الائتمان، فهي معلومات غير متاحة
                        لزوار الموقع.
                        <br />
                        نحن لا نطلب منك الكشف عن بياناتك إلا عندما يكون ذلك ضرورياً لك
                        للمشاركة في أنشطة وخدمات الموقع، مثل خدمة التبرع الإلكتروني، وتبذل
                        جمعية الخير الخيرية جهدها لحماية خصوصية الفرد بشتى الطرق.
                        <br />
                        يتم جمع البيانات الشخصية في حالات الضرورة القصوى، وبعدد مرات محدود
                        وذلك لحماية خصوصيتك.
                        <br />
                        سيتم استخدام البيانات للغرض المطلوب ثم حذفها بعد ذلك، إلا إذا كنا
                        ملزمين قانونيًا بفعل خلاف ذلك.
                        <br />
                        لدينا ضمانات لحماية بياناتك الشخصية، وامكانية وصول المختصين فقط لتلك
                        البيانات عند الضرورة القصوى.
                        <br />
                        لا نجمع معلومات شخصية من الأطفال الذين يزورون موقعنا، فإذا كنت تحت سن
                        16 عام فيرجى الحصول على إذن والديك قبل استخدام الموقع، وقبل تقديم أي
                        بيانات شخصية في هذا الموقع.
                        <br />
                        في خدمة التعليقات يكون من الممكن نشر المعلومات المعلن عنها والتي يمكن
                        الوصول اليها، ولكن لا نقوم بنشر عنوان البريد الإلكتروني.
                        <br />
                        يشمل موقعنا على إمكانية اختيار موافقتك على تلقي رسائل منا عبر البريد
                        الإلكتروني، فنحن نقوم بإبلاغ المشتركين بأي تغيير في الموقع، أو نخبرهم
                        بميزات جديدة عن محتويات الموقع.
                    </div>
                </div>
                <div className="flex flex-col justify-start px-5 py-8 mt-8 w-full rounded-xl border border-solid backdrop-blur-[10px] bg-zinc-50 border-zinc-300 max-md:max-w-full">
                    <div className="self-start text-xl font-bold text-right text-black whitespace-nowrap">
                        السرية والأمان
                    </div>
                    <div className="mt-2 text-base text-justify text-zinc-900 max-md:max-w-full">
                        نحن نقدم لك خيار استخدام معيار الصناعة SSL لحماية المعلومات، لكي ترسل
                        لنا المعلومات الشخصية الأساسية وتفاصيل بطاقات الائتمان وكلمات السر
                        الخاصة بك. لدينا ضمانات مادية والكترونية واجرائية لحماية البيانات
                        الشخصية الخاصة بك، وقمنا بتنفيذ السياسات الأمنية والاجراءات الفنية
                        لحماية تلك البيانات، وهي تخضع لسيطرتنا ولا يمكن استخدامها بشكل غير
                        سليم أو تعديلها أو فقدانها، ولا يتم تبادل تلك المعلومات أو بيعها لأي
                        طرف ثالث لأغراض التسويق.
                        <br />
                        <br />
                        الموظفون والقائمون على معالجة البيانات ملتزمون باحترام سرية البيانات
                        الشخصية لزوارنا، ونقوم بطلب البيانات التي نعتقد أنها ضرورية من أجل
                        توفير الخدمات لك، أحيانا تكون الخدمات آلية على الموقع، وبالتالي فإن
                        ذلك يحد من الحاجة الى الموظفين أو غيرهم لعرض المعلومات الشخصية، وعلينا
                        أن نضمن أنه لن يتم الكشف عن البيانات الشخصية لمؤسسات الدولة والسلطات
                        إلا إذا كان ذلك مطلوبًا بموجب القانون أو لائحة أخرى.
                    </div>
                </div>
                <div className="flex flex-col justify-start px-5 py-8 mt-8 w-full rounded-xl border border-solid backdrop-blur-[10px] bg-zinc-50 border-zinc-300 max-md:max-w-full">
                    <div className="self-start text-xl font-bold text-right text-black whitespace-nowrap">
                        المعلومات الغير شخصية
                    </div>
                    <div className="mt-2 text-base text-justify text-zinc-900 max-md:max-w-full">
                        عندما يدخل الزوار إلى موقعنا تصلنا تلقائيًا بعض المعلومات غير المحددة
                        للهوية الشخصية مثل نظام تشغيل الكمبيوتر ونوع المتصفح وعنوان ال IP
                        للزائر.
                        <br />
                        تقوم جمعية الخير الخيرية باستخدام تلك المعلومات الغير شخصية للأغراض
                        التالية:
                        <br />
                        الإدارة التقنية وتطوير المواقع
                        <br />
                        تسويق التحليل الإحصائي
                    </div>
                </div>
                <div className="flex flex-col justify-start px-5 py-8 mt-8 w-full rounded-xl border border-solid backdrop-blur-[10px] bg-zinc-50 border-zinc-300 max-md:max-w-full">
                    <div className="self-start text-xl font-bold text-right text-black whitespace-nowrap">
                        سياسة ملفات تعريف الارتباط (Cookies)
                    </div>
                    <div className="mt-2 text-base text-justify text-zinc-900 max-md:max-w-full">
                        قد نقوم بتخزين ما يسمى بملفات تعريف الارتباط &quot;Cookies&quot; على
                        الجهاز الخاص بك عندما تقوم بزيارة موقعنا، حيث أن ملفات تعريف الارتباط
                        &quot;Cookies&quot; هي جزء من البيانات التي تحددك كمستخدم بشكل فريد،
                        كما يمكن استخدامها لتحسين معرفتك بهذه البوابة الإلكترونية ولفهم قاعدة
                        مستخدم هذه البوابة على نحو أفضل.
                        <br />
                        <br />
                        يتم إعداد معظم المستعرضات في البداية لقبول ملفات تعريف الارتباط، كما
                        يمكنك إعادة إعداد المتصفح الخاص بك لرفض كافة ملفات تعريف الارتباط أو
                        للتنبيه عندما يتم إرسال ملفات تعريف الارتباط، كما يرجى ملاحظة أن بعض
                        الخدمات التي يتم عرضها على البوابة قد لا تعمل بشكل صحيح إذا قمت برفض
                        ملفات تعريف الارتباط، حيث أننا قد نقوم بربط المعلومات المخزنة في هذه
                        الملفات بأي معلومات تعريف شخصية تقدمها على موقعنا.
                    </div>
                </div>
                <div className="flex flex-col justify-start px-5 py-8 mt-8 rounded-xl border border-solid backdrop-blur-[10px] bg-zinc-50 border-zinc-300 max-md:max-w-full">
                    <div className="self-start text-xl font-bold text-right text-black whitespace-nowrap">
                        مواقع أخرى
                    </div>
                    <div className="mt-2 text-base text-justify text-zinc-900 max-md:max-w-full">
                        أي موقع آخر لا يخص جمعية الخير الخيرية أو أي روابط أخرى من مواقع
                        الانترنت الخارجية لا تمثلنا، الجمعية ليست مسئولة عن محتوى المواقع
                        الخارجية.
                    </div>
                </div>
            </div>
        </>
    )
}

export default Privacy